import {forwardRef, Ref} from 'react'
import {InputNumber as AntdInputNumber, InputNumberProps} from 'antd'

export default forwardRef(function InputAmount(
  props: InputNumberProps,
  ref: Ref<HTMLInputElement>
) {
  const handleFormat = (value: any) =>
    `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  const handleParse = (value: any) => value!.replace(/\$\s?|(,*)/g, '')

  return (
    <AntdInputNumber
      ref={ref}
      size="large"
      min={1}
      formatter={handleFormat}
      parser={handleParse}
      {...props}
    />
  )
})
